module.exports = __webpack_public_path__ + "static/media/plus.84f4b643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/plus.svg
// module id = 538
// module chunks = 0